import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRadiusTopLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.682 1.875h-3.24a3.5 3.5 0 0 0-3.5 3.5v3.364a.5.5 0 0 1-1 0V5.376a4.5 4.5 0 0 1 4.5-4.5h3.24a.5.5 0 0 1 0 1M3.676 9.57a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3 .75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.5-.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m2.678-3.699a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-.75-2.974a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 5.199a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopLeft12);
